export const ID_NAMESPACE = 'id'

// Mutations
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_ERROR = 'SET_ERROR'
